import React from 'react';
import PropTypes from 'prop-types';
import Fetch from '../Fetch';
import ServiceDialog from '../Layout/StandardPageTemplate/Context/ServiceDialog';
import { urlResolver as defaultUrlResolver } from '../../utils/resolvers';

export default class FetchTiles extends React.Component {
  static propTypes = {
    name: PropTypes.string.isRequired,
    children: PropTypes.func.isRequired,
    urlResolver: PropTypes.func,
    imageResolver: PropTypes.func,
    iconColorResolver: PropTypes.func,
  };

  defaultImageResolver = ({ imageUrl }) => {
    return require(`../../assets/images/${imageUrl ||
      'cardImageFallback.jpg'}`);
  };

  convertToTile = item => {
    const { urlResolver, imageResolver, iconColorResolver } = this.props;
    return Object.assign(
      {},
      {
        ...item,
        link:
          typeof urlResolver === 'function'
            ? urlResolver(item)
            : defaultUrlResolver(item.url),
        imageUrl:
          typeof imageResolver === 'function'
            ? imageResolver(item)
            : null,
        iconColor:
          typeof iconColorResolver === 'function'
            ? iconColorResolver(item)
            : item.iconColor,
      }
    );
  };

  render() {
    return (
      <Fetch url={`/api/config/pages/${this.props.name}`}>
        {({ isPending, data, error }) => {
          if (data) {
            return this.props.children(data.items.map(this.convertToTile));
          }
          if (error) {
            return <ServiceDialog />;
          }
          return null;
        }}
      </Fetch>
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/components/FetchTiles/index.js